(() => {
  let countRequest = 0;
  async function refreshCount() {
    const request = ++countRequest;
    try {
      const response = await fetch(window.routes.cart_url + '.js', {cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== countRequest) return;
      document.querySelectorAll('[data-lp-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = !cart.item_count;
        const link = el.closest('a');
        if (link) link.setAttribute('aria-label', window.libasepkStrings.cartLabel.replace('[count]', cart.item_count));
      });
    } catch {}
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-lpc-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const card = select.closest('.lpc');
    const quantity = card.querySelector('[name="quantity"]');
    if (quantity) quantity.value = option.dataset.min || 1;
    const price = card.querySelector('[data-lpc-price]');
    const priceTemplate = document.getElementById(option.dataset.priceId);
    if (price && priceTemplate) price.replaceChildren(priceTemplate.content.cloneNode(true));
    else if (price && option.dataset.price) price.textContent = option.dataset.price;
  });
  document.addEventListener('lp:cart-added', event => {
    showToast(window.libasepkStrings.added, event.detail?.product_title || event.detail?.title || '', false);
    refreshCount();
    const form = event.target;
    const button = form.querySelector('[type="submit"]');
    const label = button?.querySelector('span');
    if (!button || !label) return;
    const original = label.textContent;
    label.textContent = window.libasepkStrings.added;
    button.classList.add('lp-added');
    const feedback = form.querySelector('[data-lp-add-feedback]');
    if (feedback) feedback.textContent = window.libasepkStrings.added;
    clearTimeout(form.lpAddedTimer);
    form.lpAddedTimer = setTimeout(() => {
      button.classList.remove('lp-added');
      if (!button.disabled) label.textContent = original;
      if (feedback) feedback.textContent = '';
    }, 1800);
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lp-open-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (trigger && drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open(trigger);
    }
  });
  let activeToast;
  function showToast(title, detail, error = false) {
    if (typeof Toastify !== 'function') return;
    activeToast?.hideToast();
    const content = document.createElement('div');
    content.className = 'lp-toast__content';
    const heading = document.createElement('strong');
    heading.textContent = title;
    content.append(heading);
    if (detail) {
      const description = document.createElement('span');
      description.className = 'lp-toast__detail';
      description.textContent = detail;
      content.append(description);
    }
    if (!error) {
      const link = document.createElement('a');
      link.href = window.routes.cart_url;
      link.textContent = window.libasepkStrings.viewCart + ' →';
      link.setAttribute('data-lp-open-cart', '');
      link.addEventListener('click', () => activeToast?.hideToast());
      content.append(link);
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'lp-toast__close';
    close.setAttribute('aria-label', window.libasepkStrings.close);
    close.textContent = '×';
    content.append(close);
    const toast = Toastify({
      node: content,
      duration: 6500,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true,
      className: error ? 'lp-toast lp-toast--error' : 'lp-toast',
      ariaLive: error ? 'assertive' : 'polite',
      style: { background: '#fffaf0' }
    });
    activeToast = toast;
    toast.showToast();
    close.addEventListener('click', () => toast.hideToast());
    toast.toastElement.addEventListener('focusin', () => clearTimeout(toast.toastElement.timeOutValue));
    toast.toastElement.addEventListener('focusout', event => {
      if (!toast.toastElement.contains(event.relatedTarget)) toast.toastElement.timeOutValue = setTimeout(() => toast.hideToast(), 6500);
    });
  }
  document.addEventListener('lp:cart-error', event => showToast(window.libasepkStrings.addError, event.detail.message, true));
  window.addEventListener('pageshow', refreshCount);
  function initChat(scope = document) {
    scope.querySelectorAll('[data-lp-chat]').forEach(chat => {
      if (chat.dataset.ready) return;
      chat.dataset.ready = 'true';
      const trigger = chat.querySelector('[data-lp-chat-toggle]');
      const panel = chat.querySelector('.lp-chat__panel');
      const closeButton = chat.querySelector('[data-lp-chat-close]');
      function close(restoreFocus = false) {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded','false');
        if (restoreFocus) trigger.focus();
      }
      trigger.addEventListener('click', () => {
        const opening = panel.hidden;
        panel.hidden = !opening;
        trigger.setAttribute('aria-expanded',String(opening));
        if (opening) closeButton.focus();
      });
      closeButton.addEventListener('click', () => close(true));
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !panel.hidden) close(true);
      });
      document.addEventListener('pointerdown', e => {
        if (!panel.hidden && !chat.contains(e.target)) close();
      });
      chat.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!panel.hidden && !chat.contains(document.activeElement)) close();
        });
      });
    });
  }
  function init() {
    initChat();
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',e => initChat(e.target));
})();

